/* Presentation only: existing membership actions own identity, review and checkout. */
(() => {
  const requestedPlan = (new URLSearchParams(location.search).get('plan') || '').split('_').pop();
  document.querySelectorAll('[data-billing-picker]').forEach(picker => {
    const choices = [...picker.querySelectorAll('input[name="membership-billing"]')];
    if (requestedPlan === 'annual' || requestedPlan === 'monthly') {
      choices.forEach(choice => { choice.checked = choice.value === requestedPlan; });
    }
    const showSelection = () => {
      const selected = choices.find(choice => choice.checked)?.value || 'annual';
      picker.querySelectorAll('[data-billing-panel]').forEach(panel => {
        panel.hidden = panel.dataset.billingPanel !== selected;
        panel.querySelectorAll('[data-plan-link]').forEach(link => {
          const destination = new URL(link.href, location.href);
          if (panel.dataset.billingPanel === 'monthly') destination.searchParams.set('plan', 'monthly');
          else destination.searchParams.delete('plan');
          link.href = destination.href;
        });
      });
    };
    choices.forEach(choice => choice.addEventListener('change', showSelection));
    showSelection();
  });
})();
